import { StyleSheet } from 'aphrodite';
import { gray } from '../../../../aida/styles/colors';
import { aceGray, brandPrimary } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	modal: {
		minWidth: 450,
		minHeight: 400,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: 20,
	},
	modalIcon: {
		margin: '0 0 20px 0',
		height: 80,
		width: 80,
	},
	modalTitle: {
		color: brandPrimary,
		fontSize: 18,
		margin: '0 0 20px 0',
		textAlign: 'center',
	},
	modalDescription: {
		fontSize: 14,
		lineHeight: '20px',
		margin: '0 0 20px 0',
		width: '100%',
		maxWidth: 400,
	},
	footer: {
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
		maxWidth: 400,
		gap: 10,
	},
	formGroup: {
		marginBottom: 16,
		width: '100%',
	},
	selectBoxContainer: {
		width: '100%',
		marginTop: 8,
	},
	selectBoxMenu: {
		maxHeight: 200,
		overflowY: 'auto',
		borderRadius: 8,
		boxSizing: 'border-box',
		border: `1px solid ${aceGray}`,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
	},
	selectBoxTrigger: {
		fontSize: 14,
		height: 40,
		width: '100%',
		border: `1px solid ${gray}`,
		borderRadius: 4,
		padding: '0 12px',
		':hover': {
			borderColor: brandPrimary,
		},
	},
	textarea: {
		backgroundColor: '#F5F6F7',
		border: `1px solid ${gray}`,
		borderRadius: 4,
		boxSizing: 'border-box',
		fontSize: 14,
		height: 120,
		marginTop: 8,
		padding: 10,
		resize: 'vertical',
		width: '100%',
	},
});
